window.addEventListener('load', () => {
    if (!window.matchMedia('(max-width: 767px)').matches) return;

    const track = document.querySelector('.blog-section__filters');
    if (!track) return;

    const active = track.querySelector('.blog-section__filter.is-active');
    if (!active) return;

    active.scrollIntoView({
        block: 'nearest',
        inline: 'start',
        behavior: 'auto'
    });
});
